var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.locales),function(l,i){return _c('span',{key:l},[(i > 0)?_c('span',{staticClass:"lang-separator"},[_vm._v("|")]):_vm._e(),_c('a',{staticClass:"locale",class:_vm.isLocaleSelected(l),attrs:{"href":_vm.$route.path},on:{"click":function($event){return _vm.setLocale(l)}}},[_vm._v(" "+_vm._s(l.toUpperCase())+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }